import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

export interface DotMenuEvent {
  id: string
  event: MouseEvent
}
export interface DotMenuItem {
  id: string
  title: string
}

@Component({
    selector: 'dot-menu',
    template: `
<div class="dot-menu" [matMenuTriggerFor]="dotMenu" (click)="$event.stopPropagation()">
  <icon class="more" matIcon="more_vert"></icon>
</div>
<mat-menu #dotMenu="matMenu" xPosition="before">
  <button mat-menu-item *ngFor="let item of dotMenuItems"
    (click)="select.emit({ id: item.id, event: $event })"
  >{{ item.title }}</button>
</mat-menu>
`,
    styles: [`
  icon { color: #999; cursor: pointer; }
`],
    standalone: true,
    imports: [MatMenuModule, IconComponent, CommonModule],
})
export class DotMenuComponent {
  @Input() dotMenuItems: DotMenuItem[] = []
  @Output() select: EventEmitter<DotMenuEvent> = new EventEmitter()
}



